import { combineReducers } from "redux";
import { sessionReducer } from "redux-react-session";
import loginReducer from "./loginReducer";
import Dropdown from "./Account/reducer";
import fileUploadReducer from "./fileUpload/reducer";
import locationReducer from "./locations/reducer";
import Opportunitie from "./Opportunities/reducer";
import Activity from "./Activity/reducer";
import currentLocationReducer from "./currentLocation/reducer";
import Lead from "./Lead/reducer";
import Common from "./Common/reducer";
import Task from "./Task/reducer";
import NotificationReducer from "./Notification/reducer";
import AssignmentReducer from "./Assignment/reducer";
import Dealer from "./Dealer/reducer";
import FasttagToll from "./FasttagToll/reducer";
import Valet from "./Valet/reducer";
import CarService from "./CarService/reducer";
import Parking from './Parking/reducer'
import BA from './BA/reducer';
import DCC from './DCC/reducer';
import AttendanceRegularization from './AttendanceReqularization/reducer'
import Journey from "./Journey/reducer";
import LoginReducerSSO from "./Login/reducer";
import Referral from "./Referral/reducer";
import RaiseTicket from "./RaiseTicket/reducer";
import DarwinAttendanceSync from "./DarwinAttendance/reducer";
import LeadManagement from "./LeadManagement/reducer";

const rootReducer = combineReducers({
    session: sessionReducer,

    loginReducer,
    Dropdown,
    fileUploadReducer,
    locationReducer,
    Opportunitie,
    Activity,
    currentLocationReducer,
    Lead,
    Common,
    Task,
    NotificationReducer,
    AssignmentReducer,
    Dealer,
    FasttagToll,
    Valet,
    CarService,
    Parking,
    BA,
    DCC,
    AttendanceRegularization,
    Journey,
    LoginReducerSSO,
    Referral,
    RaiseTicket,
    DarwinAttendanceSync,
    LeadManagement
});

export default rootReducer;
